import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'work-ui-chart-progress',
  templateUrl: './chart-progress.component.html',
  styleUrls: ['./chart-progress.component.scss'],
  standalone: true,
  imports: [],
})
export class ChartProgressComponent {
  readonly showNumbers = input<boolean>(true);
  readonly total = input<number>(100);
  readonly reached = input<number>(0);
  readonly showTotal = input<boolean>(true);
  readonly showPercentage = input<boolean>(false);

  protected readonly percentageReached = computed<number>(() => (Number(this.reached()) / this.total()) * 100);
}
